<template>
  <layout>
    <page-header :actions="actions" :header="$t('users.title')" />
    <div class="content">
      <admin-table v-bind="tableProps" @api-result="updateExportUrl">
        <template slot="avatar" slot-scope="{ item }">
          <div class="media">
            <div class="media-left mr-2">
              <div class="h-10 w-10">
                <img
                  v-if="item.avatar && item.avatar.url"
                  :src="thumb(item.avatar, 60, 60, true)"
                  class="rounded-full max-w-full"
                  alt=""
                />
                <avatar
                  v-else
                  :username="item.name"
                  :size="40"
                  :custom-style="{ maxWidth: '100%', maxHeight: '100%' }"
                  :rounded="true"
                />
              </div>
            </div>
            <div class="media-body">
              {{ item.name }}
            </div>
          </div>
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import Avatar from 'vue-avatar'
import UsersApi from './UsersApi'

const resourceBase = 'users'

export default {
  name: 'UsersIndex',

  components: {
    AdminTable,
    Avatar,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder() {
          return new UsersApi().setParameters({
            context: 'list',
          })
        },
        sortBy: 'created_at',
        sortDesc: true,
        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
            sortable: true,
          },
          {
            key: 'avatar',
            label: this.$t('users.avatar'),
          },
          {
            key: 'company_name',
            label: this.$t('users.company'),
          },
          {
            key: 'email',
            label: this.$t('users.email'),
            sortable: true,
          },
          {
            key: 'bookings_count',
            label: this.$t('users.bookings'),
            sortable: true,
          },
          {
            key: 'created_at',
            label: this.$t('users.registered'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // define custom row actions
        // eslint-disable-next-line no-unused-vars
        rowActions: item => {
          let actions = []

          if (
            this.$allows(`${resourceBase}.update`) ||
            this.$allows(`${resourceBase}.serve`) ||
            this.$allows(`${resourceBase}.view`)
          ) {
            actions.push('edit')
          }
          if (this.$allows(`${resourceBase}.delete`)) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },

        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'query',
            placeholder: this.$t('users.search'),
          },
          {
            component: 'text-field',
            attribute: 'where.id',
            placeholder: this.$t('users.user_id'),
          },
          {
            component: 'date-range-field',
            attribute: 'where.created_at',
            placeholder: this.$t('users.select_register_period'),
          },
        ],
        searchData: {
          query: null,
          where: {
            id: null,
            created_at: null,
          },
        },
      },
      exportUrl: null,
    }
  },

  computed: {
    // Page header actions
    actions() {
      const actions = []
      if (this.$allows(`${resourceBase}.create`)) {
        actions.push({
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        })
      }
      if (this.$allows('administer') && this.exportUrl) {
        actions.push({
          id: 'export',
          text: this.$t('general.export'),
          icon: 'icon-download',
          onClick: () => {
            window.open(this.exportUrl, '_blank')
          },
        })
      }
      return actions
    },
  },

  methods: {
    updateExportUrl(result) {
      this.exportUrl = result.export_url
    },
  },
}
</script>
